import React, { useState } from 'react';
import { SecurityEventsDashboard } from '../../components/security/SecurityEventsDashboard';
import { ThreatSimulationDashboard } from '../../components/security/ThreatSimulationDashboard';
import { ShieldIcon, BellIcon, SettingsIcon, BarChart3Icon, UsersIcon, LogOutIcon, AlertTriangleIcon, LayoutDashboardIcon } from 'lucide-react';
const SecurityMonitoringPage: React.FC = () => {
  const [activeTab, setActiveTab] = useState<'dashboard' | 'events' | 'threats' | 'alerts' | 'settings' | 'analytics'>('events');
  return <div className="bg-white dark:bg-[#0F1F1D] min-h-screen" data-id="element-5337">
      <div className="flex h-screen overflow-hidden" data-id="element-5338">
        {/* Sidebar */}
        <div className="hidden md:flex md:flex-shrink-0" data-id="element-5339">
          <div className="flex flex-col w-64 border-r border-gray-200 dark:border-[#1A3330] bg-white dark:bg-[#162825]" data-id="element-5340">
            <div className="h-0 flex-1 flex flex-col pt-5 pb-4 overflow-y-auto" data-id="element-5341">
              <div className="flex items-center flex-shrink-0 px-4" data-id="element-5342">
                <ShieldIcon className="h-8 w-8 text-[#2DB489] dark:text-[#4ED1A0]" data-id="element-5343" />
                <span className="ml-2 text-xl font-semibold text-gray-900 dark:text-white" data-id="element-5344">
                  Security Center
                </span>
              </div>
              <nav className="mt-8 flex-1 px-2 space-y-1" data-id="element-5345">
                <button onClick={() => setActiveTab('dashboard')} className={`group flex items-center px-2 py-2 text-sm font-medium rounded-md w-full ${activeTab === 'dashboard' ? 'bg-[#2DB489]/10 dark:bg-[#4ED1A0]/10 text-[#2DB489] dark:text-[#4ED1A0]' : 'text-gray-600 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-[#1A3330]'}`} data-id="element-5346">
                  <LayoutDashboardIcon className="mr-3 h-5 w-5" data-id="element-5347" />
                  Dashboard
                </button>
                <button onClick={() => setActiveTab('events')} className={`group flex items-center px-2 py-2 text-sm font-medium rounded-md w-full ${activeTab === 'events' ? 'bg-[#2DB489]/10 dark:bg-[#4ED1A0]/10 text-[#2DB489] dark:text-[#4ED1A0]' : 'text-gray-600 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-[#1A3330]'}`} data-id="element-5348">
                  <ShieldIcon className="mr-3 h-5 w-5" data-id="element-5349" />
                  Security Events
                </button>
                <button onClick={() => setActiveTab('threats')} className={`group flex items-center px-2 py-2 text-sm font-medium rounded-md w-full ${activeTab === 'threats' ? 'bg-[#2DB489]/10 dark:bg-[#4ED1A0]/10 text-[#2DB489] dark:text-[#4ED1A0]' : 'text-gray-600 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-[#1A3330]'}`} data-id="element-5350">
                  <AlertTriangleIcon className="mr-3 h-5 w-5" data-id="element-5351" />
                  Threat Detection
                </button>
                <button onClick={() => setActiveTab('alerts')} className={`group flex items-center px-2 py-2 text-sm font-medium rounded-md w-full ${activeTab === 'alerts' ? 'bg-[#2DB489]/10 dark:bg-[#4ED1A0]/10 text-[#2DB489] dark:text-[#4ED1A0]' : 'text-gray-600 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-[#1A3330]'}`} data-id="element-5352">
                  <BellIcon className="mr-3 h-5 w-5" data-id="element-5353" />
                  Alert Management
                </button>
                <button onClick={() => setActiveTab('analytics')} className={`group flex items-center px-2 py-2 text-sm font-medium rounded-md w-full ${activeTab === 'analytics' ? 'bg-[#2DB489]/10 dark:bg-[#4ED1A0]/10 text-[#2DB489] dark:text-[#4ED1A0]' : 'text-gray-600 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-[#1A3330]'}`} data-id="element-5354">
                  <BarChart3Icon className="mr-3 h-5 w-5" data-id="element-5355" />
                  Security Analytics
                </button>
                <button onClick={() => setActiveTab('settings')} className={`group flex items-center px-2 py-2 text-sm font-medium rounded-md w-full ${activeTab === 'settings' ? 'bg-[#2DB489]/10 dark:bg-[#4ED1A0]/10 text-[#2DB489] dark:text-[#4ED1A0]' : 'text-gray-600 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-[#1A3330]'}`} data-id="element-5356">
                  <SettingsIcon className="mr-3 h-5 w-5" data-id="element-5357" />
                  Configuration
                </button>
              </nav>
            </div>
            <div className="flex-shrink-0 flex border-t border-gray-200 dark:border-[#1A3330] p-4" data-id="element-5358">
              <div className="flex-shrink-0 w-full group block" data-id="element-5359">
                <div className="flex items-center" data-id="element-5360">
                  <div data-id="element-5361">
                    <UsersIcon className="inline-block h-9 w-9 rounded-full text-gray-500 dark:text-gray-400" data-id="element-5362" />
                  </div>
                  <div className="ml-3" data-id="element-5363">
                    <p className="text-sm font-medium text-gray-700 dark:text-gray-200" data-id="element-5364">
                      Security Team
                    </p>
                    <button className="text-xs font-medium text-gray-500 dark:text-gray-400 group-hover:text-gray-700 dark:group-hover:text-gray-300 flex items-center" data-id="element-5365">
                      <LogOutIcon className="h-3 w-3 mr-1" data-id="element-5366" />
                      Sign out
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Main content */}
        <div className="flex flex-col w-0 flex-1 overflow-hidden" data-id="element-5367">
          <main className="flex-1 relative z-0 overflow-y-auto focus:outline-none" data-id="element-5368">
            {activeTab === 'dashboard' && <div className="p-8" data-id="element-5369">
                <h1 className="text-2xl font-bold text-gray-900 dark:text-white mb-6" data-id="element-5370">
                  Security Dashboard
                </h1>
                <p className="text-gray-500 dark:text-gray-400" data-id="element-5371">
                  Security dashboard overview would be implemented here, showing
                  key metrics, recent threats, and active responses.
                </p>
              </div>}
            {activeTab === 'events' && <SecurityEventsDashboard data-id="element-5372" />}
            {activeTab === 'threats' && <ThreatSimulationDashboard data-id="element-5373" />}
            {activeTab === 'alerts' && <div className="p-8" data-id="element-5374">
                <h1 className="text-2xl font-bold text-gray-900 dark:text-white mb-6" data-id="element-5375">
                  Alert Management
                </h1>
                <p className="text-gray-500 dark:text-gray-400" data-id="element-5376">
                  Alert management functionality would be implemented here,
                  allowing configuration of alert destinations, thresholds, and
                  notification preferences.
                </p>
              </div>}
            {activeTab === 'analytics' && <div className="p-8" data-id="element-5377">
                <h1 className="text-2xl font-bold text-gray-900 dark:text-white mb-6" data-id="element-5378">
                  Security Analytics
                </h1>
                <p className="text-gray-500 dark:text-gray-400" data-id="element-5379">
                  Security analytics would be implemented here, showing trends,
                  patterns, and statistics about security events over time.
                </p>
              </div>}
            {activeTab === 'settings' && <div className="p-8" data-id="element-5380">
                <h1 className="text-2xl font-bold text-gray-900 dark:text-white mb-6" data-id="element-5381">
                  Security Configuration
                </h1>
                <p className="text-gray-500 dark:text-gray-400" data-id="element-5382">
                  Security configuration settings would be implemented here,
                  allowing adjustment of logging, alerting, and monitoring
                  parameters.
                </p>
              </div>}
          </main>
        </div>
      </div>
    </div>;
};
export default SecurityMonitoringPage;